type Image = {
  [key: string]: string;
};

const imageAll = import.meta.glob(['./*/*.*', './*.*'], {
  as: 'url',
  eager: true,
});

const IMAGES: Image = {};

Object.keys(imageAll).forEach((path) => {
  IMAGES[path.replace(/(\.\/|\.js)/g, '')] = imageAll[path];
});

export default IMAGES;
